import { IEdge, INode } from '@ardoq/yfiles';
import { Edge, Node } from './props';

export type NodeTag = {
  node: Node;
};

export type EdgeTag = {
  edge: Edge;
};

export type TaggedGraphNode = INode & {
  tag: NodeTag;
};

export type TaggedGraphEdge = IEdge & {
  tag: EdgeTag;
};

export const isNode = (item: unknown): item is TaggedGraphNode =>
  item instanceof INode && 'tag' in item && 'node' in item.tag;

export const isEdge = (item: unknown): item is TaggedGraphEdge =>
  item instanceof IEdge && 'tag' in item && 'edge' in item.tag;

// With folding enabled the view graph also contains yFiles-managed folder nodes and
// aggregated folding edges that do NOT carry our `{node}`/`{edge}` tag. These accessors
// return undefined for those so reconciliation/selection skip them rather than
// dereferencing a missing tag.
export const nodeId = (node: INode): string | undefined =>
  (node.tag as NodeTag | undefined)?.node?.id;

export const isOurEdge = (edge: IEdge): edge is TaggedGraphEdge =>
  (edge.tag as EdgeTag | undefined)?.edge?.id !== undefined;
